import { useEffect, useState } from 'react';
import _ from 'lodash';
import { IFilterAllData, ListOfKeysFilterAllData, PlacementShowModule } from 'src/typings/filter';
import { useBuildType } from 'src/hooks';

export const useGenerateShowingInfo = <T extends { [key: string]: { use: boolean } }>(data: T, property?: IFilterAllData) => {
  const { isCrossTable } = useBuildType();
  const [renderItems, setRenderItems] = useState<{ [key: string]: T}>({});

  useEffect(() => {
    if (_.isObject(data)) {
      const willRenderItems: any = {};
      Object.keys(data).forEach((item) => {
        const prices = [
          ListOfKeysFilterAllData.placementTotalPrice,
          ListOfKeysFilterAllData.placementTotalPriceAlternative,
          ListOfKeysFilterAllData.placementPricePerSqM,
          ListOfKeysFilterAllData.placementPricePerSqMAlternative,
        ];
        const showInModule = !isCrossTable && prices.includes(item as ListOfKeysFilterAllData)
          && property?.[ListOfKeysFilterAllData.placementStatusShowInModule] === PlacementShowModule.hide;
        if (data[item].use && !showInModule) {
          willRenderItems[item] = data[item];
        }
      });

      setRenderItems(willRenderItems);
    }
  }, [data, isCrossTable, property]);

  return renderItems;
};
